import React from 'react';
import { BrainIcon, ClipboardListIcon, HeartPulseIcon, LeafIcon, SaladIcon, ScaleIcon, WavesIcon } from 'lucide-react';
type Scope = {
  title: string;
  description: string;
  icon: typeof LeafIcon;
};
const scopes: Scope[] = [{
  title: 'Fitoterapia nativa',
  description: 'Referencia educativa sobre Sarandí, Carqueja y Pezuña de Vaca, con preparaciones, usos y precauciones.',
  icon: LeafIcon
}, {
  title: 'Biodescodificación',
  description: 'Preguntas de exploración y worksheets para abordar el componente emocional de forma complementaria.',
  icon: BrainIcon
}, {
  title: 'Nutrición consciente',
  description: 'Recetario criollo, lista de compras y propuestas de organización alimentaria para entregar al paciente.',
  icon: SaladIcon
}, {
  title: 'Monitoreo consciente',
  description: 'Bitácora de 21 días para registrar hábitos, emociones y datos de seguimiento de forma ordenada.',
  icon: ClipboardListIcon
}, {
  title: 'Meditaciones guiadas',
  description: 'Recursos de audio y práctica corporal orientados a la calma y al bienestar emocional.',
  icon: WavesIcon
}, {
  title: 'Suplementación orientativa',
  description: 'Fichas comparativas y checklist de seguridad para conversar desde un marco educativo y responsable.',
  icon: ScaleIcon
}, {
  title: 'Consulta paso a paso',
  description: 'Una estructura de entrevista complementaria para sumar orden a tu práctica profesional.',
  icon: HeartPulseIcon
}];
export function CollectionIndex() {
  return <section className="mx-auto max-w-5xl" aria-labelledby="scope-title" data-id="element-18" data-mp="nuuiiu9cjjxw"><div className="mb-8 text-center" data-id="element-19" data-mp="nub2xk7657n1"><p className="text-xs font-bold tracking-[.18em] text-brand-goldDark uppercase" data-id="element-20" data-mp="a3xqp5n8v6rw">Cobertura completa, abordaje integral</p><h3 id="scope-title" className="mt-3 text-3xl font-bold text-brand-ink" data-id="element-21" data-mp="f1z8ln8xp01s">Un recurso para cada momento de la consulta</h3></div><div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="12qs9zz8bs03s">{scopes.map(scope => {
        const Icon = scope.icon;
        return <article key={scope.title} className="border border-brand-green/20 bg-white p-5" data-id="element-23" data-mp="17l6663utab9i"><Icon className="h-6 w-6 text-brand-goldDark" aria-hidden="true" data-id="element-24" data-mp="1heai77l3jcuy" /><h4 className="mt-4 font-display text-xl font-bold text-brand-greenDark" data-id="element-25" data-mp="1cfph75y0sp5g">{scope.title}</h4><p className="mt-2 text-sm leading-relaxed text-brand-muted" data-id="element-26" data-mp="17gcs0ejof5zp">{scope.description}</p></article>;
      })}</div></section>;
}